var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinumNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PLATINUM-nav 3",
    clipPath: "url(#clip0_3756_2518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3756_2518",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 51
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_15695_96033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54 0H0V51H54V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3756_2518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLATINUM-nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Molecule / Avatar / Profile 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.58C36.1944 47.58 45.08 38.6944 45.08 26.5C45.08 14.3055 36.1944 5.42 24 5.42C11.8055 5.42 2.92 14.3055 2.92 26.5C2.92 38.6944 11.8055 47.58 24 47.58ZM24 49.5C37.2548 49.5 47 39.7548 47 26.5C47 13.2452 37.2548 3.5 24 3.5C10.7452 3.5 1 13.2452 1 26.5C1 39.7548 10.7452 49.5 24 49.5Z",
    fill: "url(#paint0_linear_3756_2518)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 37 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4414 6.50783V6.28022C29.4414 3.95541 32.1846 2.56262 33.9862 4.0942L36.5911 5.81134L38.0411 1.95175L38.0973 1.83807C39.1246 -0.241396 42.066 -0.236403 43.087 1.84535L43.1427 1.95888L44.5529 5.7423L46.8472 4.16702C48.6314 2.57491 51.4414 3.95471 51.4414 6.31214V6.5403L49.0518 19.8182C48.884 21.1683 47.7524 22.2813 46.2877 22.2813H34.5951C33.1302 22.2813 31.9984 21.1678 31.8309 19.8173L29.4414 6.50783ZM34.3303 19.4704C34.3303 19.6208 34.4489 19.7427 34.5951 19.7427H46.2877C46.434 19.7427 46.5526 19.6208 46.5526 19.4704L48.9206 6.31214C48.9206 6.05809 48.6124 5.94235 48.4533 6.13664L43.6546 9.43136C43.5322 9.58082 43.3012 9.55299 43.2156 9.37858L40.8268 2.96942C40.729 2.77014 40.4526 2.76972 40.3543 2.96871L37.9413 9.39147C37.857 9.56236 37.6318 9.59251 37.5077 9.44945L32.4247 6.09882C32.2627 5.91217 31.9623 6.03002 31.9623 6.28022L34.3303 19.4704ZM30.9976 8.19214L31.057 8.23127C31.0371 8.21861 31.0173 8.20557 30.9976 8.19214ZM49.9293 8.19553C49.9034 8.21413 49.8774 8.23204 49.8511 8.24926L49.9293 8.19553Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M34.3303 19.4705L31.9623 6.28033C31.9623 6.03013 32.2627 5.91229 32.4247 6.09893L37.5077 9.44958C37.6318 9.59255 37.857 9.56249 37.9413 9.3916L40.3542 2.96882C40.4525 2.76983 40.729 2.77025 40.8268 2.96952L43.2156 9.37871C43.3012 9.55312 43.5322 9.58095 43.6546 9.43149L48.4533 6.13675C48.6124 5.94246 48.9206 6.05821 48.9206 6.31225L46.5526 19.4705C46.5526 19.6209 46.434 19.7429 46.2877 19.7429H34.5951C34.4489 19.7429 34.3303 19.6209 34.3303 19.4705Z",
    fill: "url(#paint1_linear_3756_2518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 42 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.711 8.39899C33.9608 8.3508 34.2022 8.51569 34.25 8.7673L36.0357 18.1543C36.0835 18.4059 35.9198 18.649 35.6699 18.6972C35.42 18.7454 35.1787 18.5805 35.1308 18.3289L33.3452 8.94183C33.2974 8.69023 33.4611 8.44719 33.711 8.39899Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6052 5.92936C40.843 6.02044 40.9624 6.28838 40.872 6.52782L40.033 8.74898C39.9425 8.98842 39.6764 9.1087 39.4387 9.01762C39.2009 8.92654 39.0814 8.6586 39.1719 8.41915L40.0109 6.198C40.1013 5.95855 40.3674 5.83828 40.6052 5.92936Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3756_2518",
    x1: 0.0000017138,
    y1: 2.5,
    x2: 51.5924,
    y2: 46.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#71AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A58D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3756_2518",
    x1: 33.3011,
    y1: 2.81982,
    x2: 49.3476,
    y2: 16.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#71AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A58D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3756_2518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumNav);
export default __webpack_public_path__ + "static/media/PLATINUM-nav.e41fe2bbe4ca8f07496a50ec12d7fca5.svg";
export { ForwardRef as ReactComponent };